const returning = ( state = false, action ) => {
    switch( action.type ) {
        case "SET_RETURNING":
            return true;
        default:
            return state;
    }
} ;

export default returning;


// WEBPACK FOOTER //
// ./src/reducers/returning.js